import styled from 'styled-components';
import { theme } from 'utils/style/theme';

const InputStyled = styled.input`
  background-color: #fff;
  border: 1px solid ${theme.colors.gray_5};
  border-radius: 0.4rem;
  padding: 4px 36px 4px 16px;
  width: ${(props) => (props.width ? props.width : '100%')};
  min-height: 40px;
  &:hover {
    border: 1px solid #4096ff;
  }
`;

export default InputStyled;
